const appModalConstants = {
  MESSAGE_SEND: 'MESSAGE_SEND',
  MESSAGE_REMOVED: 'MESSAGE_REMOVED',
  LOADER_ON: 'LOADER_ON',
  LOADER_OFF: 'LOADER_OFF',
  ERROR_MODAL_CLOSED: "ERROR_MODAL_CLOSED",
  ERROR_MODAL_OPENED: "ERROR_MODAL_OPENED",
  SET_PATH_REDIRECT: "SET_PATH_REDIRECT"
};

export default appModalConstants;
